import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/core/helper/common.service';
import { DataStorage } from 'src/app/core/helper/data.storage';
import { PmdSidebar } from 'src/app/shared/propeller';
import { PrintService } from '../../core/helper/print.service';

@Component({
  selector: 'app-download-print-navbar',
  templateUrl: './download-print-navbar.component.html',
  styleUrls: ['./download-print-navbar.component.scss'],
  host: {
    class: 'container-fluid',
  }
})
export class DownloadPrintNavbarComponent implements OnInit {

  @ViewChild(PmdSidebar) leftSidebar;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private dataStorage: DataStorage,
    private commonService: CommonService,
    private printService: PrintService
  ) {

  }

  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian' }
  ];

  changeLang() {
    // console.log('===========change language======', this.language)
    this.commonService.changeLanguage(this.language)
  }

  ngOnInit() {

  }

  toggleSideBar() {
    // this.leftSidebar.toggleSideBar();
    this.commonService.sideBarToggle.emit();
  }

  print() {
    this.printService.printDocument("/summary-invoice");
  }
}
